"use client";

import { useEffect } from "react";
import { getOrSetUserID, getOrSetUserClass } from "/utils/actions";
import { sendImpressionWithPayload } from "/utils/serverImpressions";
import { ImpressionEvent } from "../utils/model";
import { usePathname } from "next/navigation";
import { useAppContext } from "/context/app-context";

const PageViewTracker = () => {
  const { userID, userClass, countryCode } = useAppContext();
  const pathname = usePathname();

  useEffect(() => {
    const trackPageView = async () => {
      // Get browser headers (since `headers()` doesn't work in Client Components)
      const url = window.location.href;
      const referrer = document.referrer;
      const userAgent = navigator.userAgent;

      const payload = {
        event: ImpressionEvent.PAGE_VIEW,
        url,
        referrer,
        user_agent: userAgent,
        countryCode,
        userID,
        userClass,
      };
      try {
        // Send impression
        await sendImpressionWithPayload(payload);
      } catch (error) {
        console.error("Failed to send impression:", error);
      }
    };

    trackPageView();
  }, [pathname, userID, userClass, countryCode]);

  return null;
};

export default PageViewTracker;
